<template>
  <b-card class="page-view-table">
    <div
      v-if="onProgress"
      class="data-loading d-flex justify-content-center"
    >
      <b-spinner
        class="mt-1"
        label="Loading"
      />
    </div>
    <!-- search input -->
    <div class="custom-search d-flex justify-content-end">
      <!--      <b-form-checkbox-->
      <!--        v-model="filterShowTodayPages"-->
      <!--        name="show-today"-->
      <!--        switch-->
      <!--        class="show-today"-->
      <!--        @change="filterShowTodayPagesChanged"-->
      <!--      >-->
      <!--        Show Today-->
      <!--      </b-form-checkbox>-->
      <b-form-group>
        <div class="d-flex align-items-center">
          <b-form-input
            v-model="searchTerm"
            placeholder="Search"
            type="text"
            @input="handleSearch"
          />
        </div>
      </b-form-group>
    </div>
    <!-- tables -->
    <vue-good-table
      :columns="columns"
      :rows="rows"
      :rtl="direction"
      style-class="vgt-table video-table"
      :search-options="{
        enabled: true,
        externalQuery: searchTerm,
        searchFn: searchTable,
      }"
      :pagination-options="{
        enabled: true,
        perPage:pageLength
      }"
      @on-sort-change="onSortChange"
    >
      <template
        slot="table-row"
        slot-scope="props"
      >
        <!-- Column: index -->
        <span
          v-if="props.column.field === 'index'"
          class="text-nowrap"
        >
          <span class="text-nowrap">{{ props.row.originalIndex + 1 }}</span>
        </span>

        <span
          v-else-if="props.column.field === 'videoLabel'"
          class="page-view-item"
        >
          <b-img
            v-if="props.row.videoPosterUrl"
            :src="props.row.videoPosterUrl"
            height="40px"
            width="40px"
          />
          <a
            class="font-weight-bold ml-1"
            @click="openDetails(props.row)"
            v-html="props.row.videoLabel"
          /><br>
        </span>

        <span
          v-else-if="props.column.field === 'pvCount'"
          class="page-view-item"
        >
          <span
            v-if="props.row.pvCount"
            class="page-view-count font-weight-bold"
          >{{ props.row.pvCount.toLocaleString() }}</span><br>
        </span>
        <span
          v-else-if="props.column.field === 'videoPlayCount'"
          class="page-view-item"
        >
          <span
            v-if="props.row.videoPlayCount"
          >{{ props.row.videoPlayCount.toLocaleString() }}</span><br>
          <span
            v-if="props.row.pvCount"
          >view: {{ props.row.pvCount.toLocaleString() }}</span>
        </span>
        <span
          v-else-if="props.column.field === 'videoLaunchRatio'"
        >
          <b-progress
            v-b-tooltip.hover
            max="100"
            height="20px"
            variant="secondary"
            :title="`${props.row.videoLaunchRatio}%`"
          >
            <b-progress-bar :value="props.row.videoLaunchRatio">
              <span><strong>{{ props.row.videoLaunchRatio }}%</strong></span>
            </b-progress-bar>
          </b-progress>
        </span>
        <span
          v-else-if="props.column.field === 'videoCompletedRation'"
        >
          <b-progress
            v-b-tooltip.hover
            max="100"
            height="20px"
            variant="secondary"
            :title="`${props.row.videoCompletedRation}%`"
          >
            <b-progress-bar :value="props.row.videoCompletedRation">
              <span><strong>{{ props.row.videoCompletedRation }}%</strong></span>
            </b-progress-bar>
          </b-progress>
        </span>
        <span v-else>
          {{ props.formattedRow[props.column.field] }}
        </span>
      </template>

      <!-- pagination -->
      <template
        slot="pagination-bottom"
        slot-scope="props"
      >
        <div class="d-flex justify-content-between flex-wrap">

          <!-- page length -->
          <div class="d-flex align-items-center mb-0 mt-1">
            <span class="text-nowrap ">
              Showing 1 to
            </span>
            <b-form-select
              v-model="pageLength"
              :options="pages"
              class="mx-1"
              @input="(value)=>props.perPageChanged({currentPerPage:value})"
            />
            <span class="text-nowrap"> of {{ props.total }} entries </span>
          </div>

          <!-- pagination -->
          <div>
            <b-pagination
              :value="1"
              :total-rows="props.total"
              :per-page="pageLength"
              first-number
              last-number
              align="right"
              prev-class="prev-item"
              next-class="next-item"
              class="mt-1 mb-0"
              @input="(value)=>props.pageChanged({currentPage:value})"
            >
              <template #prev-text>
                <feather-icon
                  icon="ChevronLeftIcon"
                  size="18"
                />
              </template>
              <template #next-text>
                <feather-icon
                  icon="ChevronRightIcon"
                  size="18"
                />
              </template>
            </b-pagination>
          </div>
        </div>
      </template>
    </vue-good-table>
  </b-card>
</template>

<script>
import {
    BCard, BPagination, BFormGroup, BFormInput, BFormSelect, VBTooltip, BSpinner, BImg, BProgress, BProgressBar,
} from 'bootstrap-vue'
import { VueGoodTable } from 'vue-good-table'
import 'prismjs'
import 'prismjs/themes/prism-tomorrow.css'
import store from '@/store'
import { getCoreApiByObjectId } from '@/coreApi/coreApiHelper'

// eslint-disable-next-line import/no-extraneous-dependencies
const moment = require('moment')

export default {
    components: {
        BCard,
        VueGoodTable,
        BPagination,
        BFormGroup,
        BFormInput,
        BFormSelect,
        BImg,
        BSpinner,
        BProgress,
        BProgressBar,
    },
    directives: {
        'b-tooltip': VBTooltip,
    },
    props: {
        videoDetails: {
            type: Object,
            required: true,
        },
        onProgress: {
            type: Boolean,
            default: true,
        },
        videoId: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            pageLength: 100,
            dir: false,
            pages: ['100', '200'],
            columns: [
                {
                    label: '',
                    field: 'index',
                    sortable: false,
                    thClass: 'table-index-item-th',
                    tdClass: 'text-center align-middle table-index-item',
                },
                {
                    label: 'Video',
                    field: 'videoLabel',
                    sortable: false,
                    hClass: 'page-title-column-th',
                    tdClass: 'text-left align-top page-title-column',
                },
                {
                    label: 'Video Duration',
                    field: 'videoDuration',
                    sortable: true,
                    thClass: 'page-title-column-th',
                    tdClass: 'text-left align-top page-title-column',
                },
                {
                    label: 'Avg Play Time',
                    field: 'videoPlayedTimeAvg',
                    type: 'number',
                    sortable: true,
                    tdClass: 'text-left page-view-column',
                },
                {
                    label: 'Launched',
                    field: 'videoPlayCount',
                    type: 'number',
                    sortable: true,
                    tdClass: 'text-left page-view-column',
                },
                {
                    label: 'Launched Ratio',
                    field: 'videoLaunchRatio',
                    sortable: true,
                    thClass: 'page-title-column-th',
                    tdClass: 'text-left align-top page-title-column',
                },
                {
                    label: 'Completed',
                    field: 'videoCompletedRation',
                    sortable: true,
                    thClass: 'page-title-column-th',
                    tdClass: 'text-left align-top page-title-column',
                },
            ],
            rows: [],
            allRows: [],
            searchTerm: '',
            filterShowTodayPages: false,
            details: null,
        }
    },
    computed: {
        direction() {
            if (store.state.appConfig.isRTL) {
                // eslint-disable-next-line vue/no-side-effects-in-computed-properties
                this.dir = true
                return this.dir
            }
            // eslint-disable-next-line vue/no-side-effects-in-computed-properties
            this.dir = false
            return this.dir
        },
    },
    watch: {
        videoDetails() {
            this.allRows = this.tableData()
            this.changeRows()
            this.detailsDataChangeDetect()
        },
        videoId() {
            if (!this.videoId && this.details) {
                this.details = null
            } else if (!(this.details && this.details.videoId !== this.videoId)) {
                this.openDetails(this.allRows.find(obj => obj.videoId === this.videoId))
            }
        },
    },
    created() {
        this.allRows = this.tableData()
        this.changeRows()
    },
    methods: {
        tableData() {
            const object = getCoreApiByObjectId(this.videoDetails, 'dailyVideoDetails')
            // console.log('dailyVideoDetails', object)
            const tableData = []
            if (
                object
                && 'data' in object
            ) {
                object.data.forEach(objectItem => {
                    const item = { ...objectItem }

                    if (!item.videoLabel) {
                        item.videoLabel = item.videoId
                    }

                    if (item.videoDuration) {
                        item.videoDuration = moment.utc(item.videoDuration * 1000).format('HH:mm:ss')
                    }

                    if (item.videoPlayedTimeAvg) {
                        item.videoPlayedTimeAvg = moment.utc(item.videoPlayedTimeAvg * 1000).format('HH:mm:ss')
                    }

                    item.videoLaunchRatio = item.videoPlayCount
                    if (item.videoPlayCount && item.pvCount) {
                        // eslint-disable-next-line no-mixed-operators
                        item.videoLaunchRatio = (item.videoPlayCount / item.pvCount * 100).toFixed(1)
                    }

                    item.videoCompletedRation = item.videoCompleted
                    if (item.videoCompleted && item.videoPlayCount) {
                        // eslint-disable-next-line no-mixed-operators
                        item.videoCompletedRation = (item.videoCompleted / item.videoPlayCount * 100).toFixed(1)
                    }

                    if (item.videoPublishedDate) {
                        item.videoPublishedDate = moment(new Date(item.videoPublishedDate * 1000)).calendar(null, {
                            sameDay: '[Today:] HH:mm',
                            nextDay: '[Tomorrow:] HH:mm',
                            nextWeek: 'dddd HH:mm',
                            lastDay: '[Yesterday:] HH:mm',
                            lastWeek: '[Last:] dddd HH:mm',
                            sameElse: 'L',
                        })
                    } else {
                        item.videoPublishedDate = null
                    }

                    if (item.videoDisplays) {
                        item.videoDisplays = JSON.parse(item.videoDisplays)
                    }

                    if (item.videoJumps) {
                        item.videoJumps = JSON.parse(item.videoJumps)
                    }

                    if (item.videoBackwardJumps) {
                        item.videoBackwardJumps = JSON.parse(item.videoBackwardJumps)
                    }

                    if (item.videoPlayedTimeTotal) {
                        item.videoPlayedTimeTotal = moment.utc(item.videoPlayedTimeTotal * 1000).format('HH:mm:ss')
                    }

                    tableData.push(item)
                })
            }
            return tableData
        },
        filterShowTodayPagesChanged() {
            this.changeRows()
        },
        changeRows() {
            let rows = this.allRows

            if (this.filterShowTodayPages) {
                rows = rows.filter(obj => obj.datePublished && obj.datePublished.indexOf('Today') > -1)
            }

            this.rows = rows
        },
        handleSearch(searching) {
        },
        handleChangePage(page) {
        },
        handlePageChange(active) {
        },
        onSortChange(params) {
        },
        searchTable(row, col, cellValue, searchTerm) {
            return !searchTerm ? true : (row.videoId && row.videoId.includes(searchTerm))
                || (row.videoLabel && row.videoLabel.includes(searchTerm))
        },
        isMobile() {
            return window.innerWidth < 768
        },
        getReferrersSlice(referers) {
            return referers.slice(0, this.isMobile() ? 3 : 8)
        },
        getOriginReferrersSlice(referers) {
            return referers.slice(0, this.isMobile() ? 3 : 8)
        },
        getReferrerCapitalizeClass(referer) {
            return !(referer.includes('www') || referer.includes('com')) ? 'text-transform-capitalize' : ''
        },
        detailsDataChangeDetect() {
            if (this.videoId) {
                this.openDetails(this.allRows.find(obj => obj.videoId === this.videoId))
            }
        },
        openDetails(details) {
            if (details) {
                this.details = details
                this.$emit('detailsSelected', {
                    details,
                })
            } else {
                this.details = null
                this.$emit('detailsSelected', {
                    details: null,
                })
            }
        },
    },
}
</script>

<style lang="scss" >
@import '~@core/scss/vue/libs/vue-good-table.scss';
</style>
